<template>
  <div id="anchor-links-group">
    <div class="mobile-links">
      <ul class="mobile-links__list">
        <li
            v-for="(item, index) in rightItems"
            :key="index"
            class="anchor-links__list-item"
        >
          <a :href="`${item.url}`" target="_blank" class="btn--dark-green generic-content__cta btn--dark-green">
            {{ item.title }}
          </a>
        </li>
      </ul>
    </div>
    <div id="anchor-link-offset" />
    <div id="anchor-links" :class="{'offset-by-crisis-bar': crisisNotificationAlert && crisisNotificationAlert.body }">
      <div class="anchor-links-wrapper anchor-links">
        <!-- Left aligned nav items -->
        <ul
            :class="{ 'anchor-links__list--open': isActive }"
            class="anchor-links__list left-hand-links"
        >
          <li
              v-for="(item, index) in leftItems"
              :key="index"
              class="anchor-links__list-item"
              @click.prevent="setSelected(index)"
          >
            <a v-scroll-to="`#${item.id}`" :href="`#${item.id}`" class="anchor-links__item-link" @keyup.stop="">
              {{ item.title }}
              <div class="tab-selector" /></a>
          </li>
        </ul>

        <!-- Right aligned nav items -->
        <ul
            :class="{ 'anchor-links__list--open': isActive }"
            class="anchor-links__list right-hand-links"
        >
          <li
              v-for="(item, index) in rightItems"
              :key="index"
              class="anchor-links__list-item"
          >
            <a :href="`${item.url}`" class="anchor-links__item-link" :target="item.openLinkInNewTab[0] && item.openLinkInNewTab[0].name === 'Yes' ? '_blank' : '_parent'">
              {{ item.title }}
              <arrow-icon class="anchor-links__item-arrow" />
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import pascalCase from 'pascal-case';
import { forceObject } from '~/utils/processor';
import { clickedShowMe } from '~/utils/gtm-events.js';
import { NAMESPACE } from '../../store/sitewide';
import ArrowIcon from '~/assets/icons/arrow-right-line-small.svg?inline';
const { mapGetters } = createNamespacedHelpers(NAMESPACE);

export default {
  components: {
    ArrowIcon,
  },
  props: {
    items: {
      type: Array,
      required: false,
      default() {
        return [
          {
            title: 'Explore Old Oak',
            icon: [
              {
                codename: 'knifeAndForks',
              },
            ],
            id: 'explore',
          },
          {
            title: 'Community & Events',
            icon: [
              {
                codename: 'knifeAndForks',
              },
            ],
            id: 'community',
          },
          {
            title: 'Rooms & Prices',
            icon: [
              {
                codename: 'knifeAndForks',
              },
            ],
            id: 'rooms',
          },
          {
            title: 'Restaurants & Bars',
            icon: [
              {
                codename: 'knifeAndForks',
              },
            ],
            id: 'restaurants',
          },
          {
            title: 'Find us',
            icon: [
              {
                codename: 'knifeAndForks',
              },
            ],
            id: 'find',
          },
          {
            title: 'Faq\'s',
            icon: [
              {
                codename: 'knifeAndForks',
              },
            ],
            id: 'faq',
          },
        ];
      },
    },
  },
  data() {
    return {
      isActive: false,
      selected: 0,
      leftItems: [],
      rightItems: [],
    };
  },
  computed: {
    selectedItem() {
      return this.leftItems[this.selected];
    },
    ...mapGetters(['crisisNotificationAlert']),
  },
  mounted() {
    this.leftItems = this.items.filter((item)=>!(item.alignment && item.alignment[0] && item.alignment[0].codename==='right'));
    this.rightItems = this.items.filter((item)=>item.alignment && item.alignment[0] && item.alignment[0].codename==='right');
    window.addEventListener('resize', this.tabIndex);
    
    // Get the navbar
    this.navbar = document.getElementById('anchor-links');
    this.navbarOffset = document.getElementById('anchor-link-offset');

    // Get the offset position of the navbar
    this.sticky = this.navbar.offsetTop;
    this.sticky = this.crisisNotificationAlert && this.crisisNotificationAlert.body ? this.sticky -68 : this.sticky;
    this.pageScrolled();
    this.tabIndex();


    window.addEventListener('scroll', this.pageScrolled);

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const id = entry.target.getAttribute('id');
        if (entry.intersectionRatio > 0) {
          document.querySelector(`ul li a[href="#${id}"]`).parentElement.classList.add('active');
        } else {
          document.querySelector(`ul li a[href="#${id}"]`).parentElement.classList.remove('active');
        }
      });
    });

    this.leftItems.forEach((section) => {
      const item = document.getElementById(section.id) || document.querySelectorAll(`section .${section.id}`)[0];
      item && this.observer.observe(item);
    });
  },
  methods: {
    openDropdown() {
      this.isActive = !this.isActive;
    },
    setSelected(index) {
      this.selected = index;
      clickedShowMe(this.$gtm, this.leftItems[this.selected].title);
      this.isActive = false;
    },
    away() {
      this.isActive = false;
    },
    getIcon(icon) {
      const iconObj = forceObject(icon);

      return pascalCase(iconObj.codename);
    },
    tabIndex() {
      // const element = document.querySelector('.anchor-links__toggle');

      // if (window.innerWidth >= LG) {
      //   element.setAttribute('tabindex', '-1');
      // } else {
      //   element.setAttribute('tabindex', '0');
      // }
    },
    pageScrolled() {
      // add debounce/throttle
      // console.log('page scrolled', e);

      if (window.pageYOffset >= this.sticky) {
        this.navbar.classList.add('sticky');
        this.navbarOffset.classList.add('active');
      } else {
        this.navbar.classList.remove('sticky');
        this.navbarOffset.classList.remove('active');
      }
    },
  },
  template: '<p v-click-outside="away">Click away</p>',
};
</script>

<style lang="scss">
@import '~/assets/scss/atomic/modules/_anchor-links.scss';
</style>
